import { QueryKey, UseMutateFunction, useMutation } from '@tanstack/react-query';
import { ApiAdminCreatePersonaKey } from '../api/apiReferencesContants';
import { ApiAdminCreatePersona } from '../api/apiReferences';
import { notifications } from '@mantine/notifications';
import { queryClient } from 'common/utils/queryClient';
import { getAdminGetAllPersonasKey } from './useAdminGetAllPersonas';

export const getAdminCreatePersonaKey = (): QueryKey => [ApiAdminCreatePersonaKey];

const useAdminCreatePersona = (): {
  mutate: UseMutateFunction<
    void,
    unknown,
    {
      persona: string;
    },
    unknown
  >;
  isLoading: boolean;
} => {
  const { mutate, isLoading } = useMutation(
    getAdminCreatePersonaKey(),
    async (data: { persona: string }) => {
      const res = await ApiAdminCreatePersona(data);
      return res;
    },
    {
      onSuccess: async () => {
        notifications.show({
          message: `Persona created successfully!`,
          autoClose: 5000,
          sx: (theme) => ({
            padding: theme.spacing.md,
            backgroundColor: theme.black,
          }),
          styles: (theme) => ({
            description: {
              color: theme.colors.green[4],
              fontWeight: 500,
              fontSize: theme.fontSizes.sm,
            },
          }),
        });

        await queryClient.invalidateQueries(getAdminGetAllPersonasKey());
      },
    },
  );

  return {
    mutate,
    isLoading,
  };
};

export default useAdminCreatePersona;
